<template>
  <span>
    <b-button
      @click="openModal"
      class="m-1"
      size="sm"
      v-b-tooltip.hover
      title="Cadastrar múltiplos itens selecionando o vencedor apenas uma vez"
    >
      <font-awesome-icon icon="trophy" class="mr-1" />
      Cadastrar itens por vencedor
    </b-button>
    <b-modal
      v-model="modalVisible"
      @hide="limparTudo"
      title="Cadastrar itens por vencedor"
      size="xl"
      centered
      scrollable
      dialog-class="zmax"
      header-bg-variant="secondary"
      header-text-variant="light"
      hide-footer
    >
      <div v-if="busy" class="d-flex justify-content-center m-3">
        <b-spinner class="m-1 text-center" />
      </div>
      <b-card-text v-else>
        <b-form-group label="Participante vencedor" class="mb-3">
          <div class="wrapper-multiselect-sagres">
            <multiselect
              v-model="participanteSelecionado"
              close-on-select
              searchable
              :show-labels="false"
              label="NmParticipante"
              deselect-label=""
              :allow-empty="true"
              placeholder="Selecione um"
              track-by="IdParticipanteLicitacao"
              :options="participantes"
              class="w-100"
              :disabled="busySelect"
              v-bind="multiselectprops"
              @select="onParticipanteSelecionado"
            >
              <template slot="noOptions">
                <small><i>Nenhum participante cadastrado</i></small>
              </template>

              <template slot="noResult">
                <i>Nenhum participante encontrado</i>
              </template>
            </multiselect>
          </div>
        </b-form-group>

        <b-row v-if="participanteSelecionado" class="mb-3">
          <b-col cols="12">
            <div class="border rounded bg-white p-3">
              <b-row class="align-items-center">
                <b-col cols="12" xl="4" class="mb-2 mb-xl-0">
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filtroBusca"
                      placeholder="Pesquisar por descrição do item"
                      :disabled="busy || busySave"
                      @keyup.enter="aplicarFiltro"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="outline-secondary"
                        :disabled="busy || busySave"
                        @click="aplicarFiltro"
                      >
                        Buscar
                      </b-button>
                      <b-button
                        variant="outline-secondary"
                        :disabled="busy || busySave"
                        @click="limparFiltro"
                      >
                        Limpar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col cols="12" xl="8" class="d-flex align-items-center justify-content-xl-end">
                  <small class="text-muted mr-2">Itens selecionados:</small>
                  <b-badge pill variant="secondary">{{ quantidadeSelecionados }}</b-badge>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    class="ml-2"
                    :disabled="
                      busy || busySave || quantidadeSelecionados === 0
                    "
                    @click="limparSelecionados"
                  >
                    Limpar selecionados
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

        <div ref="topoTabelaItens"></div>
        <b-row>
          <b-table
            v-if="participanteSelecionado"
            :fields="fields"
            :items="items"
            :busy="busy"
            primary-key="IdItemLicitacao"
            small
            hover
            no-border-collapse
            striped
            stacked="md"
            show-empty
            @row-clicked="onRowClicked"
          >
            <template #empty>
              <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
              <div class="text-center text-dark">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="loading-text">Carregando...</strong>
              </div>
            </template>
            <template #cell(selecionado)="data">
              <b-form-checkbox
                v-model="data.item.selecionado"
                :name="`cs${data.index}1`"
                :tabIndex="`${data.index}1`"
                :disabled="busySave"
                @change="onItemMarcado(data.item)"
              />
            </template>
            <template #cell(QtItemMatServ)="data">
              <span class="text-nowrap">
                {{ data.value }}
              </span>
              <small
                v-if="data.item.selecionado"
                class="d-block mt-1 text-muted font-weight-bold"
              >
                Disponível: {{ quantidadeDisponivelComUnidade(data.item) }}
              </small>
            </template>
            <template #cell(QtLicitada)="data">
              <table-form-validation-provider
                v-if="data.item.selecionado"
                :hasLabel="false"
                :rules="`required|max_value:${data.item.QtDisponivelParaLicitar}`"
                v-slot="defaultState"
                small
              >
                <b-form-input
                  :disabled="busySave"
                  v-model="data.item.QtLicitada"
                  class="text-center"
                  size="sm"
                  v-bind="licitaQtdProps"
                  :state="defaultState.state"
                  :tabIndex="`${data.index}2`"
                />
              </table-form-validation-provider>
              <span v-else class="text-muted small d-block text-center">-</span>
            </template>
            <template #cell(VlUnitarioLicitado)="data">
              <table-form-validation-provider
                v-if="data.item.selecionado"
                :hasLabel="false"
                v-slot="defaultState"
                rules="max:4000"
                small
              >
                <money
                  :disabled="busySave"
                  v-model="data.item.VlUnitarioLicitado"
                  :state="defaultState.state"
                  v-bind="vMoney4CasasOptions"
                  :tabIndex="`${data.index}3`"
                />
              </table-form-validation-provider>
              <span v-else class="text-muted small">
                {{ data.value }}
              </span>
            </template>

            <template #cell(NmMarcaItemMatServ)="data">
              <table-form-validation-provider
                v-if="data.item.selecionado"
                :hasLabel="false"
                v-slot="defaultState"
                rules="max:100"
                small
              >
                <b-form-input
                  :disabled="busySave"
                  v-model="data.item.NmMarcaItemMatServ"
                  size="sm"
                  :state="defaultState.state"
                  :tabIndex="`${data.index}4`"
                />
              </table-form-validation-provider>
              <span v-else class="text-muted small">
                {{ data.value }}
              </span>
            </template>

            <template #custom-foot>
              <b-tr class="font-weight-bold">
                <b-td colspan="3" class="text-right">Total Estimado:</b-td>
                <b-td class="text-left">
                  {{
                    licitacaoVlTotalEstimado
                      ? formatMoeda(licitacaoVlTotalEstimado)
                      : ""
                  }}
                </b-td>
                <b-td class="text-right">Total Licitado:</b-td>
                <b-td class="text-left">
                  {{
                    licitacaoVlTotalLicitado
                      ? formatMoeda(licitacaoVlTotalLicitado)
                      : ""
                  }}
                </b-td>
                <b-td class="text-left"></b-td>
              </b-tr>
              <b-tr class="">
                <b-td colspan="7" class="text-right">
                  <small
                    >Os valores totais foram calculados sem contabilizar
                    mudanças não salvas</small
                  >
                </b-td>
              </b-tr>
            </template>
          </b-table>
          <instrucoes-itens-por-vencedor v-else />
        </b-row>

        <b-row v-if="participanteSelecionado && quantidadeSelecionados > 0" class="mt-2">
          <b-col cols="12">
            <div class="border rounded bg-white painel-selecionados">
              <div
                class="painel-selecionados-header bg-secondary text-white rounded-top px-3 py-2 d-flex align-items-center"
                @click="mostrandoSelecionados = !mostrandoSelecionados"
              >
                <font-awesome-icon
                  :icon="mostrandoSelecionados ? 'chevron-up' : 'chevron-down'"
                  class="mr-2"
                />
                <small class="font-weight-bold">
                  Todos os itens selecionados ({{ quantidadeSelecionados }})
                </small>
              </div>
              <b-collapse v-model="mostrandoSelecionados">
                <div class="p-2">
                  <b-table
                    :items="itensSelecionados"
                    :fields="fieldsSelecionados"
                    small
                    striped
                    bordered
                    responsive
                    show-empty
                  >
                    <template #empty>
                      <span class="text-muted small">Nenhum item selecionado.</span>
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="(items && items.length > 0) || quantidadeSelecionados > 0" class="mt-4">
          <b-col cols="12" class="mb-2">
            <div class="border rounded bg-white p-3">
              <b-row class="align-items-center">
                <b-col cols="12" lg="4" class="mb-2 mb-lg-0"></b-col>
                <b-col cols="12" lg="5" class="d-flex justify-content-lg-center mb-2 mb-lg-0">
                  <table-pagination
                    v-if="totalRows > pageSize"
                    :total-rows="totalRows"
                    :per-page="pageSize"
                    :first-current-pg="currentPage"
                    @pageChange="pageChange"
                  />
                </b-col>
                <b-col cols="12" lg="3" class="d-flex justify-content-center justify-content-lg-end">
                  <small class="text-muted">30 itens por página</small>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col cols="12" class="d-flex justify-content-end">
            <b-button
              class="m-1"
              size="sm"
              type="submit"
              @click="salvarItens"
              :disabled="busySave || busy"
            >
              <b-spinner small v-if="busySave" class="mr-2" />
              <font-awesome-icon v-else icon="save" />
              Salvar
            </b-button>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
  </span>
</template>

<script lang="ts">
import TableFormValidationProvider from "@/components/shared/TableFormValidationProvider.vue";
import ldiService from "@/services/licitacoes/ldiService";
import { Decimal32dot4Props } from "@/types/form-default-props";
import {
  fieldsModalPorVencedor,
  fieldsResumoSelecionadosModalPorVencedor,
  quantidadeDisponivelComUnidade,
} from "@/types/licitacoes/ldi/fields-item-licitacao";
import { ItemModalVencedorLicitacao } from "@/types/licitacoes/ldi/item-modal-vencedor-licitacao";
import { ParticipanteLicitacao } from "@/types/licitacoes/ldi/participante-licitacao";
import { RetornoModalVencedorLicitacao } from "@/types/licitacoes/ldi/retornos/retorno-modal-vencedor-licitacao";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import Multiselect from "vue-multiselect";
import { MultiSelectDefaultProps } from "@/types/form-default-props";
import { Component, Vue } from "vue-property-decorator";
import { Money } from "v-money";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import InstrucoesItensPorVencedor from "./InstrucoesItensPorVencedor.vue";

const CompProps = Vue.extend({
  name: "ModalEditarItensPorVencedor",
  components: {
    InstrucoesItensPorVencedor,
    Money,
    Multiselect,
    TableFormValidationProvider,
    TablePagination,
  },
  props: {
    idLicitacao: {
      type: Number,
      required: true,
    },
  },
});

@Component
export default class ModalEditarItensPorVencedor extends mixins(
  UtilsTS,
  CompProps
) {
  readonly quantidadeDisponivelComUnidade = quantidadeDisponivelComUnidade;
  licitaQtdProps = Decimal32dot4Props;
  modalVisible = false;
  busy = false;
  busySelect = false;
  busySave = false;
  tokenControleBuscaItens = 0;
  readonly pageSize = 30;
  participantes: ParticipanteLicitacao[] = [];
  participanteSelecionado: ParticipanteLicitacao | null = null;

  fields: TableField[] = fieldsModalPorVencedor;
  items: ItemModalVencedorLicitacao[] = [];
  selectedItems: Record<number, ItemModalVencedorLicitacao> = {};
  explicitamenteDesmarcados: Record<number, boolean> = {};
  selectedCount = 0;
  selecaoInicialSincronizada = false;
  pageCache: Record<string, RetornoModalVencedorLicitacao> = {};
  currentPage = 1;
  totalRows = 0;
  filtroBusca = "";
  filtroAplicado = "";
  multiselectprops = MultiSelectDefaultProps;
  licitacaoVlTotalLicitado: number | null = null;
  licitacaoVlTotalEstimado: number | null = null;
  mostrandoSelecionados = false;

  get quantidadeSelecionados(): number {
    return this.selectedCount;
  }

  get itensSelecionados(): ItemModalVencedorLicitacao[] {
    return Object.values(this.selectedItems).sort(
      (a, b) => a.NuSequencialItem - b.NuSequencialItem
    );
  }

  readonly fieldsSelecionados = fieldsResumoSelecionadosModalPorVencedor;

  obterContextoBuscaItens(idParticipante: number): {
    page: number;
    filtro: string;
    idParticipante: number;
  } {
    return {
      page: this.currentPage,
      filtro: this.filtroAplicado,
      idParticipante,
    };
  }

  ehMesmoContextoBuscaItens(contextoBusca: {
    page: number;
    filtro: string;
    idParticipante: number;
  }): boolean {
    return (
      this.currentPage === contextoBusca.page &&
      this.filtroAplicado === contextoBusca.filtro &&
      this.participanteSelecionado?.IdParticipanteLicitacao ===
        contextoBusca.idParticipante
    );
  }

  async openModal(): Promise<void> {
    this.modalVisible = true;
  }

  async buscarParticipantes(): Promise<void> {
    try {
      this.busySelect = true;
      const response = await ldiService.buscarParticipantes(this.idLicitacao);
      if (response) {
        this.participantes = response.participantes ?? [];
      } else {
        this.$toast.error("Erro ao consultar os participantes da licitação.");
      }
    } catch (e) {
      this.tratarError(e);
    } finally {
      this.darFocoAoPrimeiroInput();
      this.busySelect = false;
    }
  }

  darFocoAoPrimeiroInput(): void {
    const inputs = document.querySelectorAll<HTMLInputElement>(
      'input[tabindex="01"]'
    );
    if (inputs.length > 0) {
      inputs[0].focus();
    }
  }

  async buscarItens(): Promise<void> {
    const aplicarResposta = (response: RetornoModalVencedorLicitacao): void => {
      this.items = response.itens;
      this.totalRows = response.totalRows ?? response.itens.length;
      this.licitacaoVlTotalLicitado = response.licitacaoVlTotalLicitado;
      this.licitacaoVlTotalEstimado = response.licitacaoVlTotalEstimado;
      this.sincronizarSelecaoInicialDaApi();
      this.aplicarSelecaoNosItensDaPagina();
    };

    const idParticipante = this.participanteSelecionado?.IdParticipanteLicitacao;
    if (!idParticipante) return;

    const contextoBusca = this.obterContextoBuscaItens(idParticipante);
    const tokenBuscaAtual = this.proximoTokenBuscaItens();

    const buscaAindaValida = (): boolean => {
      return (
        this.ehTokenBuscaAtual(tokenBuscaAtual) &&
        this.ehMesmoContextoBuscaItens(contextoBusca)
      );
    };

    const cacheKey = this.montarCacheKey(
      contextoBusca.page,
      contextoBusca.idParticipante,
      contextoBusca.filtro
    );
    const respostaCache = this.pageCache[cacheKey];
    if (respostaCache) {
      if (!buscaAindaValida()) return;
      this.busy = false;
      aplicarResposta(respostaCache);
      void this.precarregarProximaPagina(
        contextoBusca.idParticipante,
        contextoBusca.filtro
      );
      return;
    }

    try {
      this.busy = true;
      const resposta = await ldiService.buscarItensModalVencedores(
        this.idLicitacao,
        contextoBusca.idParticipante,
        contextoBusca.page,
        this.pageSize,
        contextoBusca.filtro
      );

      if (!buscaAindaValida()) return;
      this.pageCache[cacheKey] = resposta;
      aplicarResposta(resposta);
      void this.precarregarProximaPagina(
        contextoBusca.idParticipante,
        contextoBusca.filtro
      );
    } catch (e) {
      if (!buscaAindaValida()) return;
      this.tratarError(e);
      this.limparDados();
    } finally {
      if (this.ehTokenBuscaAtual(tokenBuscaAtual)) {
        this.busy = false;
      }
    }
  }

  proximoTokenBuscaItens(): number {
    this.tokenControleBuscaItens += 1;
    return this.tokenControleBuscaItens;
  }

  ehTokenBuscaAtual(token: number): boolean {
    return token === this.tokenControleBuscaItens;
  }

  invalidarBuscasItensPendentes(): void {
    this.tokenControleBuscaItens += 1;
    this.busy = false;
  }

  montarCacheKey(page: number, idParticipante: number, filtro: string): string {
    return `${idParticipante}|${page}|${this.pageSize}|${filtro.trim()}`;
  }

  limparCachePaginas(): void {
    this.pageCache = {};
  }

  async precarregarProximaPagina(
    idParticipante: number,
    filtro: string
  ): Promise<void> {
    const proximaPagina = this.currentPage + 1;
    if (this.totalRows <= this.currentPage * this.pageSize) return;

    const cacheKey = this.montarCacheKey(proximaPagina, idParticipante, filtro);
    if (this.pageCache[cacheKey]) return;

    try {
      const resposta = await ldiService.buscarItensModalVencedores(
        this.idLicitacao,
        idParticipante,
        proximaPagina,
        this.pageSize,
        filtro
      );
      this.pageCache[cacheKey] = resposta;
    } catch {
      // prefetch silencioso — falha não impacta a operação principal
    }
  }

  onItemMarcado(item: ItemModalVencedorLicitacao): void {
    if (item.selecionado) {
      item.QtLicitada = item.QtDisponivelParaLicitar;
      item.VlUnitarioLicitado = item.VlUnitarioEstimado;
    }
    this.atualizarSelecao(item);
  }

  onRowClicked(
    item: ItemModalVencedorLicitacao,
    _index: number,
    event?: MouseEvent
  ): void {
    void _index;

    if (this.busy || this.busySave) return;

    const target = (event?.target as HTMLElement | null) ?? null;
    const clicouElementoInterativo = Boolean(
      target &&
        target.closest(
        "input, button, a, select, textarea, label, .custom-control, .custom-control-label, .btn, .form-control, .page-link"
        )
    );

    if (clicouElementoInterativo) return;

    item.selecionado = !item.selecionado;
    this.onItemMarcado(item);
  }

  atualizarSelecao(item: ItemModalVencedorLicitacao): void {
    const jaSelecionado = Boolean(this.selectedItems[item.IdItemLicitacao]);

    if (item.selecionado) {
      this.$delete(this.explicitamenteDesmarcados, item.IdItemLicitacao);
      this.$set(this.selectedItems, item.IdItemLicitacao, item);
      if (!jaSelecionado) this.selectedCount += 1;
      return;
    }

    this.$set(this.explicitamenteDesmarcados, item.IdItemLicitacao, true);
    if (jaSelecionado) {
      this.$delete(this.selectedItems, item.IdItemLicitacao);
      this.selectedCount = Math.max(0, this.selectedCount - 1);
    }
  }

  sincronizarSelecaoInicialDaApi(): void {
    if (this.selecaoInicialSincronizada) return;

    this.items.forEach((item) => {
      if (!item.selecionado) return;
      this.$set(this.selectedItems, item.IdItemLicitacao, item);
    });

    this.selectedCount = Object.keys(this.selectedItems).length;
    this.selecaoInicialSincronizada = true;
  }

  aplicarSelecaoNosItensDaPagina(): void {
    this.items.forEach((item) => {
      if (this.explicitamenteDesmarcados[item.IdItemLicitacao]) {
        item.selecionado = false;
        return;
      }

      const selecionado = this.selectedItems[item.IdItemLicitacao];
      if (selecionado) {
        item.selecionado = Boolean(selecionado.selecionado);
        item.QtLicitada = selecionado.QtLicitada;
        item.VlUnitarioLicitado = selecionado.VlUnitarioLicitado;
        item.NmMarcaItemMatServ = selecionado.NmMarcaItemMatServ;
        return;
      }

      if (item.selecionado) {
        this.$set(this.selectedItems, item.IdItemLicitacao, item);
        this.selectedCount += 1;
        return;
      }

      if (!item.selecionado) {
        item.selecionado = false;
      }
    });
  }

  async pageChange(page: number): Promise<void> {
    this.currentPage = page;
    await this.buscarItens();
    this.rolarParaTopoTabela();
  }

  rolarParaTopoTabela(): void {
    this.$nextTick(() => {
      const topo = this.$refs.topoTabelaItens as HTMLElement | null;
      if (topo && typeof topo.scrollIntoView === "function") {
        topo.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      const modalBody = document.querySelector(
        ".modal.show .modal-body"
      ) as HTMLElement | null;
      if (modalBody) {
        modalBody.scrollTo({ top: 0, behavior: "smooth" });
      }
    });
  }

  async aplicarFiltro(): Promise<void> {
    this.currentPage = 1;
    this.filtroAplicado = this.filtroBusca.trim();
    this.limparCachePaginas();
    await this.buscarItens();
  }

  async limparFiltro(): Promise<void> {
    this.filtroBusca = "";
    if (!this.filtroAplicado) return;
    this.filtroAplicado = "";
    this.currentPage = 1;
    this.limparCachePaginas();
    await this.buscarItens();
  }

  limparSelecionados(): void {
    Object.keys(this.selectedItems).forEach((idItem) => {
      this.$set(this.explicitamenteDesmarcados, Number(idItem), true);
    });
    this.selectedItems = {};
    this.selectedCount = 0;
    this.items.forEach((item) => {
      item.selecionado = false;
      this.$set(this.explicitamenteDesmarcados, item.IdItemLicitacao, true);
    });
  }

  async onParticipanteSelecionado(): Promise<void> {
    this.invalidarBuscasItensPendentes();
    this.currentPage = 1;
    this.filtroBusca = "";
    this.filtroAplicado = "";
    this.limparCachePaginas();
    this.selectedItems = {};
    this.explicitamenteDesmarcados = {};
    this.selectedCount = 0;
    this.selecaoInicialSincronizada = false;
    this.limparDados();
    await this.buscarItens();
  }

  async salvarItens(): Promise<void> {
    try {
      this.busySave = true;
      const itens = this.itensSelecionados;
      if (itens.length === 0) {
        this.$toast.error("Selecione ao menos um item para salvar.");
        return;
      }
      await ldiService.salvarItensPorVencedor(
        this.idLicitacao,
        this.participanteSelecionado?.IdParticipanteLicitacao ?? 0,
        itens
      );
      this.$toast.success("Itens salvos com sucesso.");
      this.limparTudo();
    } catch (e) {
      this.tratarError(e);
    } finally {
      this.busySave = false;
    }
  }

  limparTudo(): void {
    this.invalidarBuscasItensPendentes();
    this.participanteSelecionado = null;
    this.currentPage = 1;
    this.filtroBusca = "";
    this.filtroAplicado = "";
    this.limparCachePaginas();
    this.selectedItems = {};
    this.explicitamenteDesmarcados = {};
    this.selectedCount = 0;
    this.selecaoInicialSincronizada = false;
    this.limparDados();
  }
  limparDados(): void {
    this.items = [];
    this.totalRows = 0;
    this.licitacaoVlTotalLicitado = null;
    this.licitacaoVlTotalEstimado = null;
  }

  async mounted(): Promise<void> {
    await this.buscarParticipantes();
  }
}
</script>

<style scoped>
:deep(div.modal-dialog.zmax) {
  z-index: 9980;
  min-width: 95%;
  max-width: 95%;
}

:deep(div.modal-content) {
  min-height: 50%;
  max-height: 90%;
  border-radius: 0.75rem;
  border: 1px solid #dce3eb;
  overflow: hidden;
}

@media screen and (max-width: 990px) {
  :deep(div.modal-dialog.zmax) {
    min-width: 100%;
    max-width: 100%;
    margin: 0.5rem;
  }

  :deep(div.modal-content) {
    margin-left: 0;
    max-width: 100%;
  }
}

:deep(input.form-control.form-control-sm) {
  padding-right: 0.5rem !important;
}

:deep(input.v-money) {
  border: 1px solid #ced4da;
  border-radius: 0.2rem;
  line-height: 1.5;
  height: calc(1.5em + 0.5rem + 2px);
  font-size: 0.875rem;
}

:deep(input.v-money:disabled) {
  background-color: #e9ecef;
}


:deep(.table.b-table thead th) {
  background: #f2f5f9;
  color: #2f3e4f;
  font-size: 0.81rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

:deep(.table.b-table tbody tr) {
  cursor: pointer;
}

:deep(td.naoQuebrar .invalid-feedback) {
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.painel-selecionados-header {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease;
}

.painel-selecionados-header:hover {
  background-color: #5a6268;
}

</style>


